import { motion } from 'framer-motion';
import { useEffect } from 'react';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ContextState, useAuthValue } from '../context/AuthContext';
import DefaultLayout from '../layout/DefaultLayout';
import { isFleetcare, isMindy, isOms } from '../utils';

export const VerificationSuccess: React.FC = () => {
    const { idpUser: currentUser } = useAuthValue() as ContextState;
    const { t } = useTranslation();

    const [seconds, setSeconds] = React.useState(5);
    const [textToRender, setTextToRender] = React.useState('verifyEmail.success.title');

    const navigate = useNavigate();

    // Checks upon mount whether user email verification status changes
    useEffect(() => {
        // Count down to perform redirect
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
        } else {
            navigate('/login');
        }
    }, [navigate, currentUser, seconds]);

    useEffect(() => {
        // If there is an error with verification update text to render
        currentUser
            ?.reload()
            .then(() => {
                if (!currentUser?.emailVerified) {
                    setTextToRender('verifyEmail.errors.failed');
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }, [currentUser, t]);

    if (isMindy || isFleetcare || isOms) {
        return (
            <DefaultLayout>
                <div className="w-full">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                        className="text-center"
                    >
                        <p className="text-xl font-poppins text-white">
                            {t(textToRender)} {t('verifyEmail.redirecting')} {seconds}
                        </p>
                    </motion.div>
                </div>
            </DefaultLayout>
        );
    }

    return (
        <DefaultLayout>
            <div className="flex h-20 ">
                <div className="m-auto text-center text-xl">
                    {t(textToRender)} {t('verifyEmail.redirecting')} {seconds}
                </div>
            </div>
        </DefaultLayout>
    );
};

export default VerificationSuccess;
